module.exports = __webpack_public_path__ + "static/img/expressway-text-5.e99f0951.png";